import { Button, InfoBox, Modal, ModalCloseButton, ModalDescription, ModalFooter, ModalHeader } from '@tryhackme/thm-ui-components';
import { faShare } from '@fortawesome/pro-regular-svg-icons';
import { StyledCopyText, StyledInfoText, StyledLink, StyledModalDescriptionText, StyledShareButton, StyledShareHeading, StyledShareIcon, StyledShareText, StyledTHMRoomTag } from './share-room-modal.styles';
export const ShareRoomModal = ({
  roomCode
}: {
  roomCode: string;
}) => {
  const shareLink = `${process.env.NODE_ENV === 'development' ? 'http://localhost:1337' : window.location.origin.toString()}/jr/${roomCode}`;
  return <Modal triggerElement={<StyledShareButton variant="outlined" color="secondary">
          <StyledShareIcon icon={faShare} />
          <StyledShareText>Share room</StyledShareText>
        </StyledShareButton>} data-sentry-element="Modal" data-sentry-component="ShareRoomModal" data-sentry-source-file="share-room-modal.tsx">
      <ModalHeader isSmall data-sentry-element="ModalHeader" data-sentry-source-file="share-room-modal.tsx">
        <StyledShareHeading data-sentry-element="StyledShareHeading" data-sentry-source-file="share-room-modal.tsx">Share your room</StyledShareHeading>
      </ModalHeader>

      <ModalDescription data-sentry-element="ModalDescription" data-sentry-source-file="share-room-modal.tsx">
        <StyledModalDescriptionText data-sentry-element="StyledModalDescriptionText" data-sentry-source-file="share-room-modal.tsx">
          You can share your room privately using the following link:
        </StyledModalDescriptionText>
      </ModalDescription>

      <InfoBox textToCopy={shareLink} linkButtonType="button" data-sentry-element="InfoBox" data-sentry-source-file="share-room-modal.tsx">
        <StyledCopyText data-sentry-element="StyledCopyText" data-sentry-source-file="share-room-modal.tsx">{shareLink}</StyledCopyText>
      </InfoBox>

      <StyledInfoText data-sentry-element="StyledInfoText" data-sentry-source-file="share-room-modal.tsx">
        Users can also join this room by going to their <strong>My Rooms</strong> page and entering{` `}
        <StyledTHMRoomTag data-sentry-element="StyledTHMRoomTag" data-sentry-source-file="share-room-modal.tsx">{roomCode}</StyledTHMRoomTag>
      </StyledInfoText>

      <ModalFooter isSmall data-sentry-element="ModalFooter" data-sentry-source-file="share-room-modal.tsx">
        <ModalCloseButton data-sentry-element="ModalCloseButton" data-sentry-source-file="share-room-modal.tsx" />
        <StyledLink target="_blank" to={shareLink} data-sentry-element="StyledLink" data-sentry-source-file="share-room-modal.tsx">
          <Button data-sentry-element="Button" data-sentry-source-file="share-room-modal.tsx">Check your room out</Button>
        </StyledLink>
      </ModalFooter>
    </Modal>;
};